import { render, staticRenderFns } from "./ups-downs-spot.vue?vue&type=template&id=07da5dcc&scoped=true&"
import script from "./ups-downs-spot.vue?vue&type=script&lang=js&"
export * from "./ups-downs-spot.vue?vue&type=script&lang=js&"
import style0 from "./ups-downs-spot.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ups-downs-spot.vue?vue&type=style&index=1&id=07da5dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da5dcc",
  null
  
)

export default component.exports